import 'css-chunksrc/client/pages/workloadPage/table/projectsDetail/loaderRow/styles.scss';export default {
  "row": "_row_1xfn3_1",
  "projectCell": "_projectCell_1xfn3_6",
  "icon": "_icon_1xfn3_22",
  "name": "_name_1xfn3_29",
  "cell": "_cell_1xfn3_34",
  "cellBar": "_cellBar_1xfn3_46"
};